import React, { FC, useEffect, useState } from 'react';

// Material UI
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  FormHelperText,
  Grid,
  IconButton,
  Paper,
  TextField,
  CardHeader,
  CardContent,
  Card,
  Typography,
  MenuItem,
  Divider,
  Box,
  Tooltip,
  InputAdornment,
} from '@material-ui/core';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import windowSize from '../../utils/hook/useWindowResize';

// Icons
import Icon from '@mdi/react';
import { mdiAlertOctagonOutline, mdiClose, mdiInformationOutline, mdiMinusCircle, mdiMinusCircleOutline, mdiPaperclip, mdiPlus, mdiPlusCircle } from '@mdi/js';

// types and interfaces
import {
  FeatureValues,
  PayloadCreate,
  Props,
  SelectorProps,
  Seller,
  ExternalCode
} from './interfaces';

import { PartnerCategories } from '../../products/interfaces';

// redux
import {
  clearProductAction,
  getPartnerCategoriesAction,
  getProductAction,
  getVariantAction,
  updateProductActions,
} from '../products/actions';
import { Store } from '../../redux/reducers';
import {
  makeSelectLoading,
  makeSelectPartnerCategories,
  makeSelectProduct,
  makeSelectVariant,
} from '../products/selectors';
import { connect } from 'react-redux';
import { getSellersAction, createSellerAction } from '../sellers/actions';
import { createProviderAction, getProvidersAction } from '../providers/actions';
import {
  makeSelectSellersList,
  makeSelectLoading as makeSelectSellerListLoading,
} from '../sellers/selectors';
import {
  makeSelectProvidersList,
  makeSelectLoading as makeSelectProviderListLoading,
} from '../providers/selectors';
import { makeSelectLoading as makeSelectCreateProductLoading } from '../products/selectors';

// components
import { createStructuredSelector } from 'reselect';
import { Controller, useForm } from 'react-hook-form';
import ProviderModal from './components/providerModal';

// types
import { SellerList } from '../sellers/interfaces';
import CategoryModal from './components/categoryModal';
import { ProviderList } from '../providers/interfaces';
import SellerModal from './components/sellerModal';
import ExternalCodeModal from './components/externalCodeModal';
import { createProductsActions } from '../products/actions';
import CreateProductMobile from './mobileView';
import classes from './index.module.scss';
import warehouseRepository from 'client-sdk/src/Repository/warehouses-repository';
import Vitrin from './components/vitrin';
import ProductRepository from 'client-sdk/src/Repository/product-repository';
import getProductFileReq from 'client-sdk/src/products/files';
import handleError from '../../utils/handleError';
import FileWithLink from '../../components/inputs/fileWithLink';
import { translate } from '../../utils/helpers';
import { Category } from '../products/interfaces';
import productRepository from 'client-sdk/src/Repository/product-repository';
import handleNotfication from '../../utils/handleNotfication';
import linkValidation from '../../utils/validations/linkValidation';
import theme from '../../theme';
const filter = createFilterOptions<SellerList>();

const vitrin = localStorage.getItem('vitrin') || null;
const partnerId = localStorage.getItem('partnerId');
const CreateProduct: FC<Props> = ({
  loading,
  partnerCategoriesList,
  getPartnerCategoriesDispatch,
  getSellersDispatch,
  sellerList,
  sellerListLoading,
  createSellerDispatch,
  providerList,
  getProvidersDispatch,
  providerListLoading,
  createProviderDispatch,
  getProductByIdDispatch,
  productData,
  history,
  match,
  getProductVariantDispatch,
  variantList,
}: Props): React.ReactElement => {
  const {
    handleSubmit,
    errors,
    control,
    setValue,
    getValues,
    register,
    reset,
    watch,
  } = useForm({
    sellerCode: '',
    sellerName: '',
    variantCode: '',
    imageUrl: '',
    name: 'test',
    code: '',
    categoryName: '',
    unit: 'عدد',
    codingType: '',
    shippingWeight: '',
    shippingLength: '',
    shippingWidth: '',
    shippingHeight: '',
    warehouseName: '',
    warehouseInventory: "100"
  });
  const [marketPlaceType, setMarketPlaceType] = useState(["SAZITO", "DIGIKALA", "BASALAM"])
  const [externalCodes, setExternalCodes] = useState<ExternalCode[]>([])
  const [step, setStep] = useState<number>(1);
  const [productInfo, setProductInfo] = useState<any>(null);
  const [sellerName, setSellerName] = useState<string | null>(null);
  const [providerName, setProviderName] = useState<string | null>(null);
  const [featureValues, setFeatureValues] = useState<FeatureValues[]>([]);
  const [payloadData, setPayloadData] = useState<any>(null);
  const [editMode, setEditMode] = useState(false as boolean);
  const [productId] = useState<number>(match.params.id);
  const [sellerNameValue, setSellerNameValue] = useState<
    Seller | null | undefined
  >(null);
  const [sellerIdValue, setSellerIdValue] = useState<Seller | null | undefined>(
    null
  );
  const [providerNameValue, setProviderNameValue] = useState<
    ProviderList | null | undefined
  >(null);
  const [
    categoryNameValue,
    setCategoryNameValue,
  ] = useState<PartnerCategories | null>(null);

  const [warehouseOptionsLoading, setWarehouseOptionsLoading] = useState(false);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [warehouseInformation, setWarehouseInformation] = useState({});
  const [vitrinSubmit, setVitrinSubmit] = useState({})
  const [tab, setTab] = useState(1)
  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState(null);
  const [isFileChange, setIsFileChange] = useState(false);
  const [fileLink, setFileLink] = useState<any>(null);
  const [dialog, setDialog] = useState<string>("");
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false)

  useEffect(() => {
    getPartnerCategoriesDispatch({ size: 1000 });
  }, []);

  useEffect(() => {
    if (productId) {
      setEditMode(true);
    }
  }, []);

  useEffect(() => {
    if (editMode) {
      getProductByIdDispatch({ id: productId });
      getProductVariantDispatch({ params: { 'productId.equals': productId } });
    }
  }, [editMode]);

  useEffect(() => {
    getSellersDispatch({ size: 1000 });
    getProvidersDispatch({ size: 1000 });
  }, []);

  useEffect(() => {
    if (editMode && productData && variantList.features && step === 2) {
      reset({
        variantCode: variantList?.code,
        providerName: variantList?.providerName,
        sellerName: variantList?.sellerName,
        description: variantList?.description,
        imageUrl: productData?.imageUrl
      });
      let findSeller;
      if (variantList?.sellerId) {
        findSeller = sellerList?.find(
          (el: Seller) => el.name === variantList?.sellerName
        );
        if (findSeller) setSellerNameValue(findSeller);
      }
      // let findSellerId;
      // if (variantList?.sellerId) {
      //   findSeller = sellerList?.find(
      //     (el: Seller) => el.id === variantList?.sellerName
      //   );
      //   if (findSeller) setSellerIdValue(findSellerId);
      // }
      let findProvider;
      if (variantList?.providerName) {
        findProvider = providerList?.find(
          el => el.name === variantList.providerName
        );
        if (findProvider) setProviderNameValue(findProvider);
      }
    }
  }, [productData]);

  useEffect(() => {
    if (productInfo && editMode) {
      submitProduct({});
    }
  }, [productInfo]);

  useEffect(() => {
    if (productData && partnerCategoriesList && editMode) {
      setExternalCodes(productData.externalProductCodes)
      setFileName(productData.imageFileName)
      reset(productData);
      const findCategory = partnerCategoriesList?.find(
        el => el.name === productData.categoryName
      );
      if (findCategory) {
        setCategoryNameValue(findCategory);
      }
    }
  }, [productData]);

  const getWarehouses = async (actions: any) => {
    const payload = {
      'status.equals': 'ACTIVE',
      size: 100,
    };
    setWarehouseOptionsLoading(true)
    try {
      const { response, count } = await warehouseRepository.getWarehouses({
        payload,
      });
      setWarehouseOptions(response.data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setWarehouseOptionsLoading(false);
    }
  }

  useEffect(() => {
    if (warehouseOptions.length == 0) {
      getWarehouses({});
    }
  }, [watch('warehouseName')])

  useEffect(() => {
    const westWarehouse = warehouseOptions.filter(warehouseOption => warehouseOption.id == 19)
    if (warehouseOptions.length > 0) {
      setValue('warehouseName', westWarehouse[0])
      setValue('warehouseInventory', "100")
      setWarehouseInformation(westWarehouse[0]);
    }
  }, [warehouseOptions])

  const submitProduct = ({
    sellerCode,
    sellerName,
    variantCode,
    name,
    code,
    categoryName,
    unit,
    codingType,
    weight,
    warehouseInventory,
    length,
    width,
    height,
  }: any) => {
    const category = partnerCategoriesList.find(
      el => el.name === categoryName
    )!;
    const provider = providerList.find(el => el.name == providerName);
    const seller = sellerList.find(el => el.name == sellerName);
    let payload;
    if (editMode) {
      payload = {
        categoryCode: category?.code ? category?.code : undefined,
        codingType: 'SINGLE',
        name,
        code,
        unit,
        weight,
        length,
        width,
        imageUrl: fileLink,
        height,
        shippingWeight: weight,
        shippingLength: length,
        shippingWidth: width,
        shippingHeight: height,
        id: productId,
        variants: handleVariantsSection(
          variantCode,
          provider,
          seller,
          featureValues,
          null
        ),
        externalProductCodes: externalCodes
      };
    } else {
      payload = {
        categoryCode: category?.code ? category?.code : undefined,
        codingType: 'SINGLE',
        name,
        code,
        unit: 'عدد',
        weight,
        length,
        imageUrl: fileLink,
        width,
        height,
        shippingWeight: weight,
        shippingLength: length,
        shippingWidth: width,
        shippingHeight: height,
        variants: handleVariantsSection(
          variantCode,
          provider,
          seller,
          featureValues,
          null
        ),
        warehouseId: warehouseInformation.id,
        suppliable: warehouseInventory,
        externalProductCodes: externalCodes
      };
    }
    setPayloadData(payload);
    setDialog("CONFIRM");
  };

  const handleVariantsSection = (
    variantCode: number,
    provider: ProviderList | undefined,
    seller: SellerList | undefined,
    features: FeatureValues[],
    imageUrl
  ) => {
    if (!variantCode && !provider && !seller && !features.length) {
      return undefined;
    }
    return [
      {
        code: variantCode ? variantCode : undefined,
        providerCode: provider ? provider.code : undefined,
        sellerCode: seller ? seller.code : undefined,
        featureValues: featureValues.length ? featureValues : undefined,
        imageUrl
      },
    ];
  };

  const handleCloseConfirmModal = () => {
    setDialog("");
  };

  const handleCloseSellerModal = () => {
    setDialog("");
  };

  const submitSeller = (values: Seller) => {
    const callback = () => {
      setDialog("");
      setSellerName(null);
    };
    createSellerDispatch({
      body: values,
      pagination: {},
      callback,
    });
  };

  const handleCloseProviderModal = () => {
    setDialog("");
  };

  const submitProvider = (values: ProviderList) => {
    const callback = () => {
      setDialog("");
      setProviderName(null);
    };
    createProviderDispatch({
      body: values,
      pagination: {},
      callback,
    });
  };

  const removeExternalCode = (index: number) => {
    if (index > -1) {
      const prevState = [...externalCodes];
      setMarketPlaceType(prev => [...prev, prevState[index].marketplaceType])
      prevState.splice(index, 1);
      setExternalCodes(prevState);
    }
  };

  const handleProduct = () => {
    if (editMode) {
      updateProduct(payloadData);
    } else {
      createProduct(payloadData);
    }
  };

  const updateProduct = async (body: any) => {
    try {
      setSubmitLoading(true)
      const { id } = await ProductRepository.updateProduct({ payload: { body, id: productId } })
      if (isFileChange) {
        await uploadProductFile(id)
      }
      history.push("/your-products")
      handleNotfication("کالای مورد نظر با موفقیت ویرایش شد.", "success")
    } catch (err) {
      setSubmitLoading(false)
      handleError(err.response)
    }
  }

  const createProduct = async (body: any) => {
    try {
      setSubmitLoading(true)
      const { response } = await ProductRepository.createProduct({ payload: { body } })
      if (file) {
        await uploadProductFile(response.data.id)
      }
      history.push("/your-products")
      handleNotfication("کالای شما با موفقیت ایجاد شد.", "success")
    } catch (err) {
      setSubmitLoading(false)
      handleError(err.response)
    }
  }

  const onFileDelete = () => {
    setFileLink("")
    setFile("")
    setIsFileChange(true)
    setFileName("")
  }

  const fileChange = (e: any) => {
    setFile(e.target.files[0])
    setFileName(e.target.files[0].name)
    setIsFileChange(true)
  }

  const getProductFile = async (prodId: number) => {
    try {
      const response = await getProductFileReq(prodId)
      const file = URL.createObjectURL(response.blob)
      return file;
    } catch (error: any) {
      handleError(error)
      return error;
    }
  }

  const uploadProductFile = async (id: number) => {
    const newFile = new FormData();
    newFile.append("file", file ? file : new Blob([""]));
    const action = {
      id,
      payload: newFile
    }
    try {
      await ProductRepository.uploadProductImage(action)
    } catch (error: any) {
      handleError(error)
    }
  }

  const submitExternalCode = (code: ExternalCode) => {
    const newList = marketPlaceType.filter((el: string) => el !== code.marketplaceType)
    setExternalCodes(prev => [...prev, code])
    setMarketPlaceType(newList)
    setDialog("")
  }

  const submitCategory = async (data: Category) => {
    try {
      setCategoryLoading(true)
      const response = await productRepository.createPartnerCategory({ payload: data })
      getPartnerCategoriesDispatch({ size: 1000 });
      setValue('categoryName', undefined);
      setDialog("")
      handleNotfication("دسته بندی با موفقیت اضافه شد", "success")
    } catch (error) {
      handleError(error.response)
    }
  }

  const closeImageUrlModal = () => {
    setFileLink("")
    setDialog("")
  }
  return (
    <div className={classes.root}>
      {/* <Paper
        elevation={1}
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
          width: '100%',
          // padding: '10px 0 '
        }}
      >
        <div className={classes.headerBox}>
          <Typography variant="h6" component="h2">
            {editMode ? `ویرایش کالای  ${match.params.id}` : 'ایجاد کالا '}
          </Typography>
        </div>
      </Paper> */}

      <Grid container alignItems="center">
        <form style={{ width: '100%', marginTop: "24px", backgroundColor: "#fff", padding: "24px", borderRadius: "4px" }} onSubmit={handleSubmit(submitProduct)}>
          <Grid md={12} lg={12} item spacing={2}>
            <Typography className={classes.typographyCards}>
              اطلاعات کلی کالا
            </Typography>
            <Card className={classes.card}>
              <CardContent className={classes.cardContentOrder}>
                <Grid container justifyContent='space-between' alignItems='stretch' lg={12} md={12}>
                  <Grid container item spacing={2} lg={10} md={10}>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      lg={6}
                      alignItems="center"
                    >
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <Controller
                            name="name"
                            label="نام کالا"
                            control={control}
                            rules={{
                              required: true,
                            }}
                            as={
                              <TextField
                                variant="outlined"
                                type="text"
                                fullWidth
                                id="name"
                                error={errors.name && true}
                              />}
                          />
                          <FormHelperText error focused>
                            {errors.name && 'نام کالا الزامی میباشد'}
                          </FormHelperText>
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={12}
                      md={3}
                      lg={3}
                      alignItems="center"
                    >
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <Controller
                            name="code"
                            label="کد کالا"
                            control={control}
                            rules={{
                              required: true,
                              pattern: /^[A-Za-z\d\-_]+$/,
                            }}
                            as={
                              <TextField
                                variant="outlined"
                                type="text"
                                fullWidth
                                id="code"
                                error={errors.code && true}
                              />}
                          />
                          <FormHelperText error focused>
                            {errors.code && 'کد کالا الزامی میباشد'}
                          </FormHelperText>
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={12}
                      md={3}
                      lg={3}
                      alignItems="center"
                    >
                      <div className={classes.item}>
                        {/* <Button
                          variant="outlined"
                          color="primary"
                          size="large"
                          style={{ marginBottom: "2px", marginLeft: "5px" }}
                          onClick={() => setDialog("ADD_CATEGORY")}
                        >
                          <Icon path={mdiPlusCircle} size={1.5} />
                        </Button> */}
                        <div style={{ width: '100%' }}>
                          {partnerCategoriesList?.length === 0 ? <Button
                            variant="outlined"
                            // color="primary"
                            fullWidth
                            size="large"
                            style={{ display: "flex", justifyContent: "space-between", padding: "10px" }}
                            onClick={() => setDialog("ADD_CATEGORY")}
                          >
                            <span>دسته‌بندی</span>
                            <Icon path={mdiPlusCircle} size={'30px'} color={"#25368C"} />
                          </Button> : <Controller
                            style={{ width: '100%' }}
                            control={control}
                            name="categoryName"
                            label="دسته‌بندی"
                            rules={{ required: false }}
                            render={({ onChange }) => (
                              <Autocomplete
                                id="categoryName"
                                noOptionsText="موردی یافت نشد"
                                autoComplete
                                getOptionSelected={(option, value) =>
                                  !option.btn && option.name === value.name
                                }
                                onChange={(_, newValue: any) => {
                                  if (newValue.btn) {
                                    setValue('categoryName', "");
                                    setCategoryNameValue("");
                                    return
                                  }
                                  if (newValue.inputValue) {
                                    setCategoryNameValue(newValue.inputValue);
                                    setValue('categoryName', undefined);
                                  } else {
                                    onChange(newValue.name);
                                    setCategoryNameValue(newValue);
                                  }
                                }}
                                filterOptions={(options, params: any) => {
                                  const filtered = filter(
                                    options,
                                    params
                                  ) as any;

                                  filtered.unshift({
                                    inputValue: params.inputValue,
                                    name: "دسته بندی جدید",
                                    btn: true
                                  });

                                  return filtered;
                                }}
                                options={
                                  partnerCategoriesList.length
                                    ? partnerCategoriesList
                                    : []
                                }
                                getOptionLabel={options => options.name}
                                renderOption={option => {
                                  return option.btn ? (<span style={{
                                    display: 'flex',
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                    padding: "8px"
                                  }} onClick={() => setDialog("ADD_CATEGORY")}>
                                    <span>{option?.name}</span>
                                    <Icon path={mdiPlus} size={1} />
                                  </span>) : (
                                    <span style={{ display: 'block' }}>
                                      <span>{option?.name}</span>
                                      <br />
                                      <span style={{ fontSize: '10px' }}>
                                        {option?.code}
                                      </span>
                                    </span>
                                  )
                                }}
                                loadingText="در حال بارگذاری"
                                loading={loading}
                                value={categoryNameValue!}
                                defaultValue={{
                                  code: '222',
                                  id: 2,
                                  name: 'دیجیتال',
                                }}
                                renderInput={params => (
                                  <TextField
                                    type="search"
                                    variant="outlined"
                                    {...params}
                                    label="دسته‌بندی"
                                    id="categoryName"
                                    name="categoryName"
                                    error={!!errors.categoryName}
                                    margin="normal"
                                    style={{ marginTop: 0, marginBottom: 0, borderRadius: 0 }}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <React.Fragment>
                                          {loading ? (
                                            <CircularProgress
                                              color="inherit"
                                              size={20}
                                            />
                                          ) : null}
                                          {params.InputProps.endAdornment}
                                        </React.Fragment>
                                      ),
                                    }}
                                  />
                                )}
                              />
                            )}
                          />}
                          <FormHelperText error focused>
                            {errors.categoryName && 'دسته‌بندی الزامی میباشد'}
                          </FormHelperText>
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={12}
                      md={3}
                      lg={3}
                      alignItems="center"
                    >
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <Controller
                            name="weight"
                            label="وزن (گرم)"
                            control={control}
                            rules={{
                              required: true,
                              pattern: /[0-9]/
                            }}
                            as={
                              <TextField
                                variant="outlined"
                                type="text"
                                fullWidth
                                id="weight"
                                error={errors.weight && true}
                              />}
                          />
                          <FormHelperText error focused>
                            {errors.weight?.type === 'pattern' &&
                              'کیبورد خود را انگلیسی کنید'}
                          </FormHelperText>
                          <FormHelperText error focused>
                            {errors.weight?.type === 'required' && 'وزن کالا الزامی میباشد'}
                          </FormHelperText>
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={12}
                      md={3}
                      lg={3}
                      alignItems="center"
                    >
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <Controller
                            name="length"
                            label="طول (سانتی‌متر)"
                            control={control}
                            rules={{
                              required: true,
                              pattern: /[0-9]/
                            }}
                            as={
                              <TextField
                                variant="outlined"
                                type="text"
                                fullWidth
                                id="length"
                                error={errors.length && true}
                              />}
                          />
                          <FormHelperText error focused>
                            {errors.length?.type === 'pattern' &&
                              'کیبورد خود را انگلیسی کنید'}
                          </FormHelperText>
                          <FormHelperText error focused>
                            {errors.length?.type === "required" && 'طول کالا الزامی میباشد'}
                          </FormHelperText>
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={12}
                      md={3}
                      lg={3}
                      alignItems="center"
                    >
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <Controller
                            name="width"
                            label="عرض (سانتی‌متر)"
                            control={control}
                            rules={{
                              required: true,
                              pattern: /[0-9]/
                            }}
                            as={
                              <TextField
                                variant="outlined"
                                type="text"
                                fullWidth
                                id="width"
                                error={errors.width && true}
                              />}
                          />
                          <FormHelperText error focused>
                            {errors.width?.type === 'pattern' &&
                              'کیبورد خود را انگلیسی کنید'}
                          </FormHelperText>
                          <FormHelperText error focused>
                            {errors.width?.type === "required" && 'عرض کالا الزامی میباشد'}
                          </FormHelperText>
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={12}
                      md={3}
                      lg={3}
                      alignItems="center"
                    >
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <Controller
                            name="height"
                            label="ارتفاع (سانتی‌متر)"
                            control={control}
                            rules={{
                              required: true,
                              pattern: /[0-9]/
                            }}
                            as={
                              <TextField
                                variant="outlined"
                                type="text"
                                fullWidth
                                id="height"
                                error={errors.height && true}
                              />}
                          />
                          <FormHelperText error focused>
                            {errors.height?.type === 'pattern' &&
                              'کیبورد خود را انگلیسی کنید'}
                          </FormHelperText>
                          <FormHelperText error focused>
                            {errors.height?.type === "required" && 'ارتفاع کالا الزامی میباشد'}
                          </FormHelperText>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container item lg={2} md={2}>
                    <FileWithLink
                      id="label"
                      handleChangeFileInput={fileChange}
                      file={file}
                      getFile={() => getProductFile(productId)}
                      fileName={fileName}
                      link={fileLink}
                      onClick={() => setDialog("IMAGE_URL")}
                      lable="افزودن عکس کالا"
                      onDelete={onFileDelete}
                    />
                  </Grid>
                  <Grid container className='notif'>
                    <Icon
                      path={mdiAlertOctagonOutline}
                      size={.8}
                    />
                    <Typography style={{ marginRight: "10px", fontSize: "14px" }}>
                      وارد کردن دقیق ابعاد کالا به بهبود فرایندهای جای‌گذاری کالا و ارسال سفارشات کمک می‌نماید.
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {!editMode && partnerId == 65 && (
            <>
              <Typography className={classes.typographyCards}>
                اطلاعات انبار
              </Typography>
              <Card className={classes.card}>
                <CardContent className={classes.cardContentOrder}>
                  <Grid container spacing={2} lg={12} md={12}>

                  </Grid>
                </CardContent>
              </Card>
            </>
          )}
          {!editMode && (
            <>
              <Typography className={classes.typographyCards}>
                اطلاعات تکمیلی
              </Typography>
              <Card className={classes.card}>
                <CardContent className={classes.cardContentOrder}>
                  <ul className="tabContainer">
                    <li onClick={() => setTab(1)} className={"tabItems " + (tab == 1 && "active")}>موجودی</li>
                    <li onClick={() => setTab(2)} className={"tabItems " + (tab == 2 && "active")}>تنوع کالا</li>
                  </ul>
                  <Grid
                    container
                    lg={12}
                    md={12}
                    className={classes.cardContent}
                  >
                    <Grid container item spacing={2} lg={12} md={12}>
                      {tab == 2 && <>
                        <Grid
                          container
                          item
                          xs={12}
                          md={4}
                          lg={4}
                          alignItems="center"
                        >
                          <div className={classes.item}>
                            <div className={classes.inputHolder}>
                              <Controller
                                style={{ width: '100%' }}
                                control={control}
                                name="sellerName"
                                label="نام فروشنده/تامین‌کننده"
                                render={({ onChange }) => (
                                  <Autocomplete
                                    id="sellerName"
                                    disabled={editMode}
                                    noOptionsText="موردی یافت نشد"
                                    value={sellerNameValue!}
                                    getOptionSelected={(option, value) =>
                                      option.name === value.name
                                    }
                                    onChange={(_, newValue: any) => {
                                      if (!newValue) {
                                        setSellerNameValue(null);
                                        setSellerIdValue(null);

                                        setValue('sellerName', '');
                                        return;
                                      }
                                      if (newValue.inputValue) {
                                        setDialog("ADD_SELLER");
                                        setSellerName(newValue.inputValue);
                                        setValue('sellerName', undefined);
                                      } else {
                                        onChange(newValue.name);
                                        setSellerIdValue(newValue.id);
                                        setSellerNameValue(newValue);
                                      }
                                    }}
                                    filterOptions={(options: any, params) => {
                                      const filtered = filter(
                                        options,
                                        params
                                      ) as any;

                                      if (params.inputValue !== '') {
                                        filtered.push({
                                          inputValue: params.inputValue,
                                          name: `اضافه کردن "${params.inputValue}"`,
                                        });
                                      }

                                      return filtered;
                                    }}
                                    options={sellerList.length ? sellerList : []}
                                    getOptionLabel={options => options.name}
                                    renderOption={(option: any) => (
                                      <span style={{ display: 'block' }}>
                                        <span>{option?.name}</span>
                                        <br />
                                        {/* <span style={{fontSize: '10px'}}>
                                        {option?.id}
                                      </span> */}
                                      </span>
                                    )}
                                    loadingText="در حال بارگذاری"
                                    loading={sellerListLoading}
                                    renderInput={params => (
                                      <TextField
                                        variant="outlined"
                                        {...params}
                                        style={{ marginTop: 0, marginBottom: 0 }}
                                        margin="normal"
                                        label="نام فروشنده/تامین‌کننده"
                                        InputProps={{
                                          ...params.InputProps,
                                          endAdornment: (
                                            <React.Fragment>
                                              {sellerListLoading ? (
                                                <CircularProgress
                                                  color="inherit"
                                                  size={20}
                                                />
                                              ) : null}
                                              {params.InputProps.endAdornment}
                                            </React.Fragment>
                                          ),
                                        }}
                                      />
                                    )}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </Grid>
                        <Grid
                          container
                          item
                          xs={12}
                          md={4}
                          lg={4}
                          alignItems="center"
                        >
                          <div className={classes.item}>
                            <div className={classes.inputHolder}>
                              <Controller
                                name="sellerCode"
                                label="کد فروشنده/تامین‌کننده"
                                control={control}
                                rules={{
                                  required: false
                                }}
                                as={
                                  <TextField
                                    id="sellerCode"
                                    fullWidth
                                    disabled={editMode}
                                    variant="outlined"
                                  />}
                              />
                            </div>
                          </div>
                        </Grid>
                        <Grid
                          container
                          item
                          xs={12}
                          md={4}
                          lg={4}
                          alignItems="center"
                        >
                          <div className={classes.item}>
                            <div style={{ width: '100%' }}>
                              <Controller
                                name="variantCode"
                                label="کد تنوع کالا"
                                control={control}
                                rules={{
                                  required: !!(
                                    watch('providerName') ||
                                    watch('sellerName') ||
                                    watch('description') ||
                                    featureValues.length
                                  ),
                                  pattern: /^[A-Za-z\d\-_]+$/,
                                }}
                                as={
                                  <TextField
                                    variant="outlined"
                                    type="text"
                                    disabled={editMode}
                                    fullWidth
                                    id="variantCode"
                                    error={errors.variantCode && true}
                                  />}
                              />
                              <FormHelperText error focused>
                                {errors.variantCode &&
                                  'کد تنوع کالا الزامی می باشد'}
                              </FormHelperText>
                            </div>
                          </div>
                        </Grid>
                      </>}
                      {tab == 1 && <>
                        {partnerId == 65 && <Grid
                          container
                          item
                          xs={12}
                          md={3}
                          lg={3}
                          alignItems="center"
                        >
                          <div className={classes.item}>
                            <div className={classes.inputHolder}>
                              <Controller
                                style={{ width: '100%' }}
                                control={control}
                                name="warehouseName"
                                label="انبار"
                                render={({ onChange }) => (
                                  <Autocomplete
                                    id="warehouseName"
                                    disabled={editMode}
                                    noOptionsText="موردی یافت نشد"
                                    value={warehouseInformation}
                                    getOptionSelected={(option, value) =>
                                      option.name === value.name
                                    }
                                    onChange={(_, newValue: any) => {
                                      setValue('warehouseName', newValue);
                                      setWarehouseInformation(newValue);
                                    }}
                                    options={warehouseOptions.length > 0 ? warehouseOptions : []}
                                    getOptionLabel={options => options.name}
                                    renderOption={(option: any) => (
                                      <span style={{ display: 'block' }}>
                                        <span>{option?.name}</span>
                                        <br />
                                      </span>
                                    )}
                                    loadingText="در حال بارگذاری"
                                    loading={warehouseOptionsLoading}
                                    renderInput={params => (
                                      <TextField
                                        variant="outlined"
                                        {...params}
                                        style={{ marginTop: 0, marginBottom: 0 }}
                                        margin="normal"
                                        label="انبار"
                                        InputProps={{
                                          ...params.InputProps,
                                          endAdornment: (
                                            <React.Fragment>
                                              {warehouseOptionsLoading ? (
                                                <CircularProgress
                                                  color="inherit"
                                                  size={20}
                                                />
                                              ) : null}
                                              {params.InputProps.endAdornment}
                                            </React.Fragment>
                                          ),
                                        }}
                                      />
                                    )}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </Grid>}
                        <Grid
                          container
                          item
                          xs={12}
                          md={3}
                          lg={3}
                          alignItems="center"
                        >
                          <div className={classes.item}>
                            <div className={classes.inputHolder}>
                              <Controller
                                name="warehouseInventory"
                                label="موجودی قابل تامین"
                                control={control}
                                rules={{
                                  required: true,
                                  pattern: /[0-9]/
                                }}
                                as={
                                  <TextField
                                    variant="outlined"
                                    type="text"
                                    fullWidth
                                    id="warehouseInventory"
                                    error={errors.warehouseInventory && true}
                                    InputProps={{
                                      endAdornment: (
                                          <InputAdornment position="end">
                                              <Tooltip title="با وارد کردن عدد مورد نظر شما می‌توانید سقف سفارشات ثبت شده بر روی این کالا را در صورت عدم موجودی فیزیکی معین نمایید.">
                                                  <Icon
                                                      path={mdiInformationOutline}
                                                      size={1}
                                                      color={theme.palette.primary.main}
                                                      className={classes.icon}
                                                  />
                                              </Tooltip>
                                          </InputAdornment>
                                      ),
                                    }}
                                  />}
                              />
                            </div>
                          </div>
                        </Grid>
                      </>}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </>
          )}
          <Typography className={classes.typographyCards}>
            کدهای یکپارچگی
            <Tooltip 
              title="شما می‌توانید با نسبت دادن کد کالا تعریف شده در هر یک از پلتفرم های بیرونی به کالای در حال تعریف، اقدام به معادل سازی آن با دیگر پلتفرم ها نمایید."
              style={{marginRight: "12px"}}
            >
              <Icon
                  path={mdiInformationOutline}
                  size={.8}
                  color={theme.palette.primary.main}
                  // style={{marginRight: "12px"}}
              />
            </Tooltip>
          </Typography>
          <Card className={classes.card}>
            <CardContent className={classes.cardContentOrder}>
              <Grid container spacing={2} lg={12} md={12} alignItems='center'>
                <Grid item md={2}>
                  <Button
                    variant="outlined"
                    // color="primary"
                    fullWidth
                    size="large"
                    style={{ display: "flex", justifyContent: "space-between", padding: "10px" }}
                    onClick={() => setDialog("ADD_EXTERNALCODE")}
                  >
                    <span>افزودن کد یکپارچگی</span>
                    <Icon path={mdiPlusCircle} size={'30px'} color={"#25368C"} />
                  </Button>
                </Grid>
                {externalCodes?.map((field, index) => {
                  return (
                    <Grid
                      item
                      md={2}
                    >
                      <div style={{ backgroundColor: "#25368C33", border: "1px solid #25368C", borderRadius: "4px", color: "#5B5B5B" }}>
                        <IconButton onClick={() => removeExternalCode(index)}>
                          <Icon path={mdiMinusCircle} size={'20px'} color={'#25368C'} />
                        </IconButton>
                        <span>{translate(field.marketplaceType)}: </span>
                        <span>{field.externalCode}</span>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            </CardContent>
          </Card>
          <Grid
            container
            justifyContent='flex-end'
          >
            {/* <Button
                variant="outlined"
                color="primary"
                size="medium"
                onClick={() => window.history.back()}
                style={{
                  marginRight: 'auto',
                }}
              >
                {'انصراف'}
              </Button> */}
            <Button
              type="submit"
              size="medium"
              data-cy="search"
              variant="contained"
              color="primary"
              disabled={submitLoading}
            >
              {editMode ? 'ویرایش کالا' : 'ذخیره کالا '}
            </Button>
          </Grid>
          {/* {!match.params.id && vitrin && <Vitrin
            submit={vitrinSubmit}
            setConfirm={setConfirmModal}
            setVitrinSubmit={setVitrinSubmit}
            history={history}
          />} */}
        </form>
      </Grid>
      <SellerModal
        sellerName={sellerName}
        handleClose={handleCloseSellerModal}
        open={dialog == "ADD_SELLER"}
        submitSeller={submitSeller}
        loading={sellerListLoading}
      />
      <ProviderModal
        handleClose={handleCloseProviderModal}
        open={dialog == "ADD_PROVIDER"}
        submitProvider={submitProvider}
        loading={providerListLoading}
        providerName={providerName}
      />
      <ExternalCodeModal
        handleClose={() => setDialog("")}
        open={dialog == "ADD_EXTERNALCODE"}
        submit={submitExternalCode}
        marketPlaceList={marketPlaceType}
      />
      <CategoryModal
        handleClose={() => setDialog("")}
        open={dialog == "ADD_CATEGORY"}
        submitCategory={submitCategory}
        categoryName={""}
        loading={categoryLoading}
      />
      <Dialog
        open={dialog == "CONFIRM"}
        onClose={handleCloseConfirmModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={handleCloseConfirmModal}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>

          <div className={classes.cancelTitle}>{`آیا از ${editMode ? 'ویرایش' : 'ایجاد'
            } کالای ${payloadData?.name} اطمینان دارید؟`}</div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={12} spacing={2} style={{ padding: '5px 0' }}>
              <Divider
                style={{ width: '100%', marginLeft: '0', marginRight: '0' }}
              />
              <Button
                style={{ margin: '7px', padding: '5px 30px' }}
                autoFocus
                onClick={handleCloseConfirmModal}
                variant="outlined"
                color="primary"
                size="medium"
              >
                {'انصراف'}
              </Button>
              <Button
                variant="contained"
                onClick={handleProduct}
                size="medium"
                color="primary"
                disabled={submitLoading}
              >
                {'ذخیره تغییرات'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialog === "IMAGE_URL"}
        fullWidth
        onClose={closeImageUrlModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent
          style={{ width: '100', marginBottom: '16px', overflow: 'hidden' }}
        >
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={closeImageUrlModal}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.cancelIcon}>
            <Typography variant={'h6'}>وارد کردن آدرس</Typography>
          </div>
          <div>
            <Box mt={3} />
            <Grid xs={12} container justifyContent="center">
              <Grid
                container
                item
                xs={12}
                alignItems="flex-end"
                style={{ marginBottom: '16px' }}
              >
                <div className={classes.item}>
                  <div style={{ width: '100%' }}>
                    <TextField
                      variant="outlined"
                      error={linkValidation(fileLink)}
                      fullWidth
                      type="text"
                      value={fileLink}
                      onChange={e => setFileLink(e.target.value)}
                      helperText={
                        linkValidation(fileLink) &&
                        'مقدار وارد شده باید از نوع آدرس اینترنتی باشد'
                      }
                      label={
                        <Grid container alignItems="center">
                          <Icon
                            path={mdiPaperclip}
                            size={0.9}
                            color={theme.palette.gray.main}
                          />
                          <span style={{ marginRight: '5px' }}>
                            {'آدرس فایل مورد نظر خود را وارد کنید'}
                          </span>
                        </Grid>
                      }
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <Divider />
        <DialogActions className={classes.actionsBox}>
          <Button
            onClick={closeImageUrlModal}
            variant="outlined"
            color="primary"
            size="large"
            style={{ flex: '1 1 0' }}
          >
            {'انصراف'}
          </Button>
          <Button
            color="primary"
            fullWidth
            variant="contained"
            disabled={!fileLink || linkValidation(fileLink)}
            onClick={() => setDialog("")}
            size="large"
            style={{ flex: '1 1 0' }}
          >
            {'بارگذاری عکس'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  partnerCategoriesList: makeSelectPartnerCategories(),
  sellerList: makeSelectSellersList(),
  sellerListLoading: makeSelectSellerListLoading(),
  loading: makeSelectLoading(),
  providerList: makeSelectProvidersList(),
  providerListLoading: makeSelectProviderListLoading(),
  createProductLoading: makeSelectCreateProductLoading(),
  productData: makeSelectProduct(),
  variantList: makeSelectVariant(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getPartnerCategoriesDispatch: (payload: any) =>
      dispatch(getPartnerCategoriesAction(payload)),
    getSellersDispatch: (payload: any) => dispatch(getSellersAction(payload)),
    createSellerDispatch: (payload: PayloadCreate) =>
      dispatch(createSellerAction(payload)),
    getProvidersDispatch: (payload: any) =>
      dispatch(getProvidersAction(payload)),
    createProviderDispatch: (payload: PayloadCreate) =>
      dispatch(createProviderAction(payload)),
    createProductDispatch: (payload: any) =>
      dispatch(createProductsActions(payload)),
    getProductByIdDispatch: (payload: { id: number }) =>
      dispatch(getProductAction(payload)),
    clearProductDispatch: () => dispatch(clearProductAction()),
    getProductVariantDispatch: (payload: any) =>
      dispatch(getVariantAction(payload)),
    updateProductDispatch: (payload: any) =>
      dispatch(updateProductActions(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProduct);
